import {
  addAccount,
  removeAccounts,
  setAccounts,
  updateAccount,
} from './accountActions'
import { Constants } from './accountConstants'
import { Account } from '../../../model/account.model'

type Actions =
  | ReturnType<typeof addAccount>
  | ReturnType<typeof setAccounts>
  | ReturnType<typeof updateAccount>
  | ReturnType<typeof removeAccounts>;

export function accountReducer(state: Account[] = [], action: Actions) {
  switch (action.type) {
    case Constants.ADD_ACCOUNT:
      // prevent duplicates
      let index = state.findIndex(
        (el) => el.account_id == action.payload.account_id
      )
      if (index == -1) return [...state, action.payload]
      return state
    case Constants.SET_ACCOUNTS:
      return [...action.payload]
    case Constants.UPDATE_ACCOUNT:
      return state.map((account: Account) => {
        // if id does not match, return non changed item
        if (account.account_id !== action.payload.account_id) {
          return account
        }

        // replace with the updated item
        return {
          ...account,
          ...action.payload,
          ...account.user_account,
          ...action.payload.user_account,
        }
      })
    case Constants.REMOVE_ACCOUNTS:
      return []
    default:
      return state
  }
}